/**
 * @author EdenCha <eden@nurigo.net>
 */
import React, { useState } from 'react'
import { connect } from 'react-redux'
import { setPropTypes, setDefaultProps } from 'lib/setPropTypes'
import withStyles from '@material-ui/core/styles/withStyles'
import classNames from 'classnames'

// material UI
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Badge from '@material-ui/core/Badge'
import Divider from '@material-ui/core/Divider'
import Box from '@material-ui/core/Box'
import IconButton from '@material-ui/core/IconButton'

// material ui icon
import { MdNotifications as MdNotificationsIcon } from 'react-icons/md'

// my components
import withCompWidth from 'commonHoc/withCompWidth'
import RandomSeedCanvasImage from 'components/molecules/RandomSeedCanvasImage'
import TokenExpFormatText from 'components/atoms/TokenExpFormatText'

// my containers
// import UserContainerName from 'containers/UserContainerName'
// import CommonButton from 'containers/CommonButtonContainer'

// libraries
import getComponentId from 'lib/getComponentId'
import bindStateToProps from 'lib/bindStateToProps'
import bindActionCreators from 'lib/bindActionCreators'
// import config from 'config'
import { isBusinessNumber, isEmptyString } from 'lib/detectType'
// import isEqualProps from 'lib/isEqualProps'
// import {
//   makeStyleObject as ms,
//   getClassName as cn,
//   getComponentByBreakpoint as gc
// } from 'lib/getBreakPoints'
import autoFormatAccountNumber from 'lib/autoFormatBankAccountNumber'

/**
 * (작성된 설명이 없습니다.)
 */
const NotiBadge = props => {
  const {
    cls,
    isExistImportantNoti,
    badgeContent,
    badgeInvisible = true,
    onClickNoticeList
  } = props
  return (
    <Badge
      badgeContent={badgeContent}
      invisible={badgeInvisible}
      max={99}
      color="primary"
      classes={
        badgeInvisible === false
          ? {
              root: cls?.badgeRoot,
              badge: classNames(cls?.badge, {
                [cls?.badgeAnimation]: isExistImportantNoti
              })
            }
          : {
              root: cls?.badgeRoot,
              badge: cls?.badge
            }
      }
    >
      <IconButton onClick={onClickNoticeList}>
        <MdNotificationsIcon />
      </IconButton>
    </Badge>
  )
}
const MemberInfo = props => {
  const {
    cls,
    badgeContent,
    badgeInvisible,
    isExistImportantNoti,
    memberName,
    nickName,
    onClickProfile,
    onClickNoticeList,
    onClickLogout
  } = props
  return (
    <Grid container spacing={1} alignItems="center">
      <Grid item xs="auto">
        <NotiBadge
          cls={cls}
          badgeContent={badgeContent}
          badgeInvisible={badgeInvisible}
          isExistImportantNoti={isExistImportantNoti}
          onClickNoticeList={onClickNoticeList}
        />
      </Grid>
      <Grid item xs zeroMinWidth>
        <Typography variant="body2" noWrap>
          <strong>{memberName}</strong>
          <Typography
            variant="body2"
            color="textSecondary"
            display="inline"
            style={{ marginLeft: 4 }}
          >
            ({nickName})
          </Typography>
        </Typography>
      </Grid>
      <Grid item xs="auto">
        <Grid container spacing={1} wrap="nowrap">
          <Grid item>
            <button className={cls.button} onClick={onClickProfile}>
              내 정보
            </button>
          </Grid>
          <Grid item>
            <button
              className={classNames(cls.button, cls.logoutButton)}
              onClick={onClickLogout}
            >
              로그아웃
            </button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}
const AccountInfo = props => {
  const {
    cls,
    isTrial = false,
    accountId,
    accountName = '',
    balance = 0,
    point = 0,
    todayRemainingQuota = 0,
    bankName,
    bankAccountNumber,
    businessName,
    businessNumber,
    hasExclusiveAccount,
    isDeferredPaymentAccount,

    onClickQuota,
    onClickCharge,
    onClickAccountInfo,
    onClickChangeAccount,
    onClickConvertTrial,
    onClickCreateExclusiveAccount,
    onClickCopyText,
    onOpenBusinessInfo
  } = props
  return (
    <Box>
      <Grid container spacing={1} alignItems="center">
        <Grid item xs={12} sm>
          <Grid container wrap="nowrap" spacing={1}>
            <Grid item>
              <Box className={cls.accountImg} ml={1} mr={1}>
                <RandomSeedCanvasImage
                  seed={accountId}
                  width={20}
                  height={20}
                />
              </Box>
            </Grid>
            <Grid item xs zeroMinWidth>
              <Typography noWrap>
                <strong>{accountName}</strong>
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container spacing={1} wrap="nowrap">
            {isTrial === true ? (
              <Grid item>
                <button
                  className={classNames(cls.button, cls.primaryButton)}
                  onClick={onClickConvertTrial}
                >
                  실제 계정으로 전환
                </button>
              </Grid>
            ) : (
              <>
                <Grid item>
                  <button className={cls.button} onClick={onClickAccountInfo}>
                    계정 정보
                  </button>
                </Grid>
                <Grid item>
                  <button
                    className={classNames(cls.button, cls.primaryButton)}
                    onClick={onClickChangeAccount}
                  >
                    계정 전환
                  </button>
                </Grid>
              </>
            )}
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Box className={cls.infoBox} mt={2}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Grid
                  container
                  spacing={1}
                  wrap="nowrap"
                  alignItems="flex-end"
                  justifyContent="space-between"
                >
                  <Grid item xs zeroMinWidth>
                    <Typography
                      variant="caption"
                      color="textSecondary"
                      display="block"
                      noWrap
                    >
                      잔액
                    </Typography>
                    <Typography variant="body2" noWrap>
                      <strong>{Number(balance).toLocaleString()} 원</strong>
                      {isDeferredPaymentAccount === true && (
                        <Typography
                          className={cls.badgeText}
                          variant="caption"
                          color="textSecondary"
                        >
                          후불
                        </Typography>
                      )}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <button
                      className={classNames(cls.button, cls.primaryButton)}
                      onClick={onClickCharge}
                    >
                      충전
                    </button>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Grid
                  container
                  spacing={1}
                  wrap="nowrap"
                  alignItems="flex-end"
                  justifyContent="space-between"
                >
                  <Grid item xs zeroMinWidth>
                    <Typography
                      variant="caption"
                      color="textSecondary"
                      display="block"
                      noWrap
                    >
                      포인트
                    </Typography>
                    <Typography variant="body2" noWrap>
                      <strong>{Number(point).toLocaleString()} P</strong>
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Divider />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Grid
                  container
                  spacing={1}
                  wrap="nowrap"
                  alignItems="flex-end"
                  justifyContent="space-between"
                >
                  <Grid item xs zeroMinWidth>
                    <Typography
                      variant="caption"
                      color="textSecondary"
                      display="block"
                      noWrap
                    >
                      오늘 한도
                    </Typography>
                    <Typography variant="body2" noWrap>
                      <strong>
                        {Number(todayRemainingQuota).toLocaleString()}건 남음
                      </strong>
                    </Typography>
                  </Grid>
                  <Grid item>
                    <button
                      className={classNames(cls.button)}
                      onClick={onClickQuota}
                    >
                      변경
                    </button>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Grid
                  container
                  spacing={1}
                  wrap="nowrap"
                  alignItems="flex-end"
                  justifyContent="space-between"
                >
                  <Grid item xs zeroMinWidth>
                    <Typography
                      variant="caption"
                      color="textSecondary"
                      display="block"
                      noWrap
                    >
                      사업자정보
                    </Typography>
                    <Typography variant="body2" noWrap>
                      {!isEmptyString(businessNumber) ? (
                        <strong>
                          {businessName} ({isBusinessNumber(businessNumber)})
                        </strong>
                      ) : (
                        '-'
                      )}
                    </Typography>
                  </Grid>
                  <Grid item>
                    {!isEmptyString(businessNumber) ? (
                      <button
                        className={classNames(cls.button)}
                        onClick={onOpenBusinessInfo}
                      >
                        변경
                      </button>
                    ) : (
                      <button
                        className={classNames(cls.button, cls.primaryButton)}
                        onClick={onOpenBusinessInfo}
                      >
                        등록
                      </button>
                    )}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Divider />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Grid
                  container
                  spacing={1}
                  wrap="nowrap"
                  alignItems="flex-end"
                  justifyContent="space-between"
                >
                  <Grid item xs zeroMinWidth>
                    <Typography
                      variant="caption"
                      color="textSecondary"
                      display="block"
                      noWrap
                    >
                      전용계좌
                    </Typography>
                    <Typography variant="body2" noWrap>
                      {hasExclusiveAccount ? (
                        <strong>
                          {bankName}{' '}
                          {autoFormatAccountNumber(bankAccountNumber)}
                        </strong>
                      ) : (
                        '-'
                      )}
                    </Typography>
                  </Grid>
                  <Grid item>
                    {hasExclusiveAccount ? (
                      <button
                        className={classNames(cls.button)}
                        onClick={() => onClickCopyText(bankAccountNumber)}
                      >
                        복사
                      </button>
                    ) : (
                      <button
                        className={classNames(cls.button, cls.primaryButton)}
                        onClick={onClickCreateExclusiveAccount}
                      >
                        생성
                      </button>
                    )}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Grid
                  container
                  spacing={1}
                  wrap="nowrap"
                  alignItems="flex-end"
                  justifyContent="space-between"
                >
                  <Grid item xs zeroMinWidth>
                    <Typography
                      variant="caption"
                      color="textSecondary"
                      display="block"
                      noWrap
                    >
                      계정고유번호
                    </Typography>
                    <Typography variant="body2" noWrap>
                      <strong>
                        {String(accountId)
                          .replace(/(.{4})(.{4})(.{4})/, '$1 $2 $3 ')
                          .trim()}
                      </strong>
                    </Typography>
                  </Grid>
                  <Grid item>
                    <button
                      className={classNames(cls.button)}
                      onClick={() => onClickCopyText(accountId)}
                    >
                      복사
                    </button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}
const ExpTimer = props => {
  const [remainingTime, setRemainingTime] = useState()
  return (
    <Typography
      variant="caption"
      color={remainingTime <= 1000 * 60 * 60 ? 'error' : 'textSecondary'}
      display="block"
      align="center"
      style={{ whiteSpace: 'nowrap' }}
    >
      <span>⏳</span> 로그아웃까지{' '}
      <TokenExpFormatText
        onChange={remTime => {
          setRemainingTime(remTime)
        }}
      />{' '}
      남음
    </Typography>
  )
}
let Component = ({ classes: cls, ...props }) => {
  const {
    isTrial,
    badgeContent,
    badgeInvisible,
    isExistImportantNoti,
    isDeferredPaymentAccount,
    memberName,
    nickName,
    accountId,
    accountName = '',
    balance = 0,
    point = 0,
    todayRemainingQuota = 0,
    bankName,
    bankAccountNumber,
    businessName,
    businessNumber,
    hasExclusiveAccount,

    onClickProfile,
    onClickNoticeList,
    onClickLogout,

    onClickQuota,
    onClickCharge,
    onClickAccountInfo,
    onClickChangeAccount,
    onClickConvertTrial,
    onClickCreateExclusiveAccount,
    onClickCopyText,
    onOpenBusinessInfo
  } = props
  return (
    <div
      data-compid={getComponentId('LayoutAccountInfoPopup')}
      className={cls.root}
    >
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12}>
          <MemberInfo
            cls={cls}
            badgeContent={badgeContent}
            badgeInvisible={badgeInvisible}
            isExistImportantNoti={isExistImportantNoti}
            memberName={memberName}
            nickName={nickName}
            onClickProfile={onClickProfile}
            onClickNoticeList={onClickNoticeList}
            onClickLogout={onClickLogout}
          />
        </Grid>
        <Grid item xs={12}>
          <Box ml={1}>
            <Divider />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <AccountInfo
            cls={cls}
            isTrial={isTrial}
            accountId={accountId}
            accountName={accountName}
            balance={balance}
            point={point}
            todayRemainingQuota={todayRemainingQuota}
            bankName={bankName}
            bankAccountNumber={bankAccountNumber}
            businessName={businessName}
            businessNumber={businessNumber}
            hasExclusiveAccount={hasExclusiveAccount}
            isDeferredPaymentAccount={isDeferredPaymentAccount}
            onClickQuota={onClickQuota}
            onClickCharge={onClickCharge}
            onClickAccountInfo={onClickAccountInfo}
            onClickChangeAccount={onClickChangeAccount}
            onClickConvertTrial={onClickConvertTrial}
            onClickCreateExclusiveAccount={onClickCreateExclusiveAccount}
            onClickCopyText={onClickCopyText}
            onOpenBusinessInfo={onOpenBusinessInfo}
          />
        </Grid>
        <Grid item xs={12}>
          <ExpTimer />
        </Grid>
      </Grid>
    </div>
  )
}

export const useProps = {
  //  testVar: { default: 'hello world!', type: 'string.isRequired' }
}
Component.defaultProps = setDefaultProps(useProps)
Component.propTypes = setPropTypes(useProps)
Component = withCompWidth(Component, { enabled: false })
Component = connect(bindStateToProps({}), bindActionCreators({}))(Component)

const commonStyles = theme => ({
  root: {
    padding: theme.spacing(3)
  },
  badgeRoot: {
    width: '100%'
  },
  badge: {
    top: 5,
    right: 5
  },
  badgeAnimation: {
    transform: 'translate3d(10px, -10px, 0)',
    animation: `$shake 6s cubic-bezier(.36,.07,.19,.97) infinite`
  },
  '@keyframes shake': {
    '1%, 9%': {
      transform: 'translate3d(9px, -10px, 0)'
    },
    '2%, 8%': {
      transform: 'translate3d(12px, -10px, 0)'
    },
    '3%, 5%, 7%': {
      transform: 'translate3d(6px, -10px, 0)'
    },
    '4%, 6%': {
      transform: 'translate3d(14px, -10px, 0)'
    }
  },
  button: {
    border: 'none',
    padding: theme.spacing(1),
    fontSize: theme.typography.caption.fontSize,
    color: theme.palette.text.secondary,
    borderRadius: theme.spacing(1) / 2,
    transition: 'background-color 0.3s, color 0.3s',
    cursor: 'pointer',
    backgroundColor: 'rgba(0,0,0,.03)',
    '&:hover': {
      backgroundColor: 'rgba(0,0,0,.05)',
      color: theme.palette.text.primary
    }
  },
  primaryButton: {
    backgroundColor: theme.palette.primary.main + '1f',
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.main + '52',
      color: theme.palette.primary.main
    }
  },
  logoutButton: {
    backgroundColor: '#fe60601f',
    color: '#ff1d1d',
    '&:hover': {
      backgroundColor: '#fe606052',
      color: '#ff1d1d'
    }
  },
  infoBox: {
    padding: theme.spacing(2),
    backgroundColor: '#00000005',
    borderRadius: 8
  },
  accountImg: {
    backgroundColor: '#0000000f',
    borderRadius: 4,
    overflow: 'hidden',
    border: '1px solid #ccc'
  },
  badgeText: {
    padding: 2,
    paddingLeft: 4,
    paddingRight: 4,
    borderRadius: 6,
    marginLeft: 4,
    fontWeight: 'bolder',
    backgroundColor: theme.palette.primary.main + '1f',
    color: theme.palette.primary.main
  }
})
Component = withStyles(commonStyles)(Component)

export default React.memo(Component)
